export const TPAUnavailableMessageOverlayTranslationKeys = {
	NAMESPACE: 'PLATFORM',
	TPA_LOADING_ERROR_HEADER_KEY: 'PLATFORM_Viewer_App_Didn’t_Load_Header',
	TPA_LOADING_ERROR_HEADER_DEFAULT: 'Widget Didn’t Load',
	TPA_LOADING_ERROR_TEXT1_KEY: 'PLATFORM_Viewer_App_Didn’t_Load_Sub_Text1',
	TPA_LOADING_ERROR_TEXT1_DEFAULT: 'Check your internet and refresh this page.',
	TPA_LOADING_ERROR_TEXT2_KEY: 'PLATFORM_Viewer_App_Didn’t_Load_Sub_Text2',
	TPA_LOADING_ERROR_TEXT2_DEFAULT: 'If that doesn’t work, contact us.',
	TPA_LOADING_ERROR_RELOAD_KEY: 'PLATFORM_Viewer_App_Didn’t_Load_Sub_Text3',
	TPA_LOADING_ERROR_RELOAD_DEFAULT: 'Refresh this page',
}

export const TPAPreloaderOverlayTranslationKeys = {
	NAMESPACE: 'tpaExtensionTranslations',
	TPA_LOADING_KEY: 'TPA_PRELOADER_LOADING',
	TPA_LOADING_DEFAULT: 'Loading',
}

export const TPAErrorMessageOverlayTranslationKeys = {
	NAMESPACE: 'tpaExtensionTranslations',
	TPA_LOADING_ERROR_RELOAD_KEY: 'PLATFORM_Viewer_App_Didn’t_Load_Sub_Text3',
	TPA_LOADING_ERROR_RELOAD_DEFAULT: 'Refresh this page',
	TPA_OOPS_KEY: 'tpa_oops',
	TPA_OOPS_DEFAULT: 'Oops! Something Went Wrong',
	TPA_ERROR_1_KEY: 'tpa_unavail_problems',
	TPA_ERROR_1_DEFAULT:
		"We're sorry, <b><%= appName %></b> is experiencing problems. Please give it a try later, or contact",
	TPA_ERROR_2_KEY: 'tpa_unavail_problems_2',
	TPA_ERROR_2_DEFAULT: 'for help.',
	TPA_ERROR_INSTALL_KEY: 'tpa_messages_app_installation_failed_message_title',
	TPA_ERROR_INSTALL_DEFAULT: "This App Wasn't Add to Your Site",
}
